import { ref } from 'vue'
import { useForm } from '@inertiajs/vue3'

import AddressApi from '@/Services/Api/Company/V1/AddressApi'

export function useAddressSelector(address) {
  const addressLoading = ref(false)
  const addressErrors = ref({})

  const addressForm = useForm({
    id: address?.id ?? '',
    street_number: address?.street_number ?? '',
    street_name: address?.street_name ?? '',
    unit_number: address?.unit_number ?? '',
    city: address?.city ?? '',
    city_region: address?.city_region ?? '',
    county_or_parish: address?.county_or_parish ?? '',
    state_or_province: address?.state_or_province ?? '',
    state_or_province_region: address?.state_or_province_region ?? '',
    postal_code: address?.postal_code ?? '',
    latitude: address?.latitude ?? '',
    longitude: address?.longitude ?? '',
    is_map_dirty: address?.is_map_dirty ?? false,
    country: address?.country ?? '',
  })

  const handleAddressSelection = (event) => {
    const allowedAddressValues = [
      'street_number',
      'unit_number',
      'street_name',
      'city',
      'city_region',
      'county_or_parish',
      'state_or_province',
      'state_or_province_region',
      'postal_code',
      'latitude',
      'longitude',
      'is_map_dirty',
      'country',
    ]

    allowedAddressValues.forEach((key) => {
      handleAddressUpdate({ key, value: event[key] ?? '' })
    })
  }

  const handleAddressUpdate = ({ key, value }) => {
    addressForm[key] = value
  }

  const handleAddressStore = async (onSuccess = null) => {
    addressLoading.value = true
    if (addressForm.id) {
      await AddressApi.update(addressForm.id, addressForm)
        .then(({ data }) => {
          addressLoading.value = false
          addressErrors.value = {}
          if (typeof onSuccess === 'function') {
            onSuccess(data.data)
          }
        })
        .catch((error) => {
          addressLoading.value = false
          addressErrors.value = error.response.data.data
        })
    } else {
      await AddressApi.store(addressForm)
        .then(({ data }) => {
          addressLoading.value = false
          addressErrors.value = {}
          if (typeof onSuccess === 'function') {
            onSuccess()
          }
          handleAddressUpdate({ key: 'id', value: data.data.id })
          handleAddressUpdate({ key: 'uuid', value: data.data.id })
        })
        .catch((error) => {
          addressLoading.value = false
          addressErrors.value = error.response.data.data
        })
    }
  }

  return {
    addressForm,
    handleAddressSelection,
    handleAddressStore,
    handleAddressUpdate,
    addressLoading,
    addressErrors,
  }
}
